<template>
  <div class="LeftContent">
    <div class="LeftContent_top">
      <div class="LeftContent_top_table" @click="activeFun(1)">
        <div>{{$t('DataInfo.Overview')}}</div>
        <div v-show="active_table == 1" class="Triangle" style="border-top: 10px solid #4A9E46"></div>
      </div>
      <div class="LeftContent_top_table" @click="activeFun(2)">
        <div>{{$t('DataInfo.File')}}</div>
        <div v-show="active_table == 2" class="Triangle" style="border-top:  10px solid #27BBE0"></div>
      </div>
      <div class="LeftContent_top_table" @click="activeFun(3)">
        <div>{{$t('DataInfo.Map')}}</div>
        <div v-show="active_table == 3" class="Triangle" style="border-top:  10px solid #5CB847"></div>
      </div>
      <!-- <div class="LeftContent_top_table">
          <div>API</div>
          <div v-show="active_table == 4" class="Triangle" style="border-top: 10px solid #006A9D"></div>
      </div>-->
    </div>
    <div class="LeftContent_bottom">
      <LeftConentBottom v-show="active_table == 1"></LeftConentBottom>
      <LeftDataBottom v-show="active_table == 2"></LeftDataBottom>
      <LeftMapBottom v-show="active_table == 3"></LeftMapBottom>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active_table: 1
    };
  },
  methods: {
    activeFun(val) {
      this.active_table = val;
    }
  },
  components: {
    LeftConentBottom: () => import("./LeftConentBottom.vue"),
    LeftDataBottom: () => import("./LeftDataBottom.vue"),
    LeftMapBottom: () => import("./LeftMapBottom.vue")
  }
};
</script>

<style lang="scss" scoped>
.LeftContent {
  width: 880px;
  background: #fff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  display: flex;
  flex-direction: column;
}
.LeftContent_top {
  height: 60px;
  width: 100%;
  display: flex;
  flex-direction: row;
  background: #fff;
  border-radius: 10px;
}
.LeftContent_bottom {
  flex: 1;
}
.LeftContent_top_table {
  cursor: pointer;
  // width: 280px;
  flex: 1;
  height: 60px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: relative;
  color: #fff;
  transition: 0.2s;
}
.LeftContent_top_table:hover {
  opacity: 0.8;
  transition: 0.2s;
}
.LeftContent_top_table:nth-child(1) {
  background: #4a9e46;
  margin-right: 4px;
  border-top-left-radius: 4px;
}
.LeftContent_top_table:nth-child(2) {
  background: #27bbe0;
  margin-right: 4px;
}
.LeftContent_top_table:nth-child(3) {
  background: #5cb847;
  border-top-right-radius: 4px;
  // margin-right: 4px;
}
.LeftContent_top_table:nth-child(4) {
  background: #006a9d;
  border-top-right-radius: 4px;
}
.Triangle {
  position: absolute;
  bottom: -8px;
  left: 50%;
  margin-left: -10px;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  // border-top: 10px solid ;
}
</style>